import React from 'react';
import { Tag } from 'src/@vymo/ui/atoms';
import { STATE_ID } from '../../constant';

export const getTrailsColumns = (config) => {
  const columns = config.activity?.columnConfigs || [];
  return columns
    .filter(({ visible }) => (visible?.enabledFor || []).includes('web'))
    .map((column) =>
      column.code === STATE_ID
        ? {
            ...column,
            cell: (value: string) => {
              const states = config?.activity?.states || [];

              const correspondingState = states.find(
                (event) => event?.id === value,
              );

              return <Tag label={correspondingState?.name} />;
            },
          }
        : column,
    );
};
